export function redirectUrl(): string {
    return window.location.origin + "/login";
}
